import { Button, DatePicker, Radio } from 'antd';
import React, { useEffect, useState } from 'react';
// import DatePicker from 'DatePicker';
import DateRangePicker from 'app/components/shared/app/DateRangePicker';
import LocalStorage from 'app/lib/utils/LocalStorage';
import { orZero } from 'app/lib/utils/NumUtils';
import moment from 'moment';
import close from "../../../../../../../static/images/close.png";
import filterIcon from "../../../../../../../static/images/filterIcon.png";
import refresh from "../../../../../../../static/images/refresh.png";
import './style.scss';

export default Dropdown = ({ filter, eventDetail, setFilter, allCampaigns, accountTimezone, onSearch, setMobileScroll, setIsMobileFilterOpen, isMobileFilterOpen }) => {
    const { RangePicker } = DatePicker;
    const [showFirst, setShowFirst] = useState(false);
    const [showSecond, setShowSecond] = useState(false);
    const [showThird, setShowThird] = useState({ list: false, range: false });
    const [open, setOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(screen.width <= 766);
    const [dateRangeListSelect, setDateRangeListSelect] = useState({ selected: "today", dates: [moment(), moment()] });

    const firstOptions = [
        { value: "all", title: "Originating Channel", icon: "static/icons/adaya/Adaya_Company_About_Us.svg" },
        { value: "ig", title: "Instagram", icon: "static/icons/user-journeys/instagram_01.svg" },
        { value: "fb", title: "Facebook", icon: "static/icons/user-journeys/facebook_01.svg" },
        { value: "google", title: "Google", icon: "static/icons/user-journeys/google_01.svg" },
        { value: "email", title: "Email", icon: "static/icons/user-journeys/email_01.svg" },
        { value: "text", title: "Text", icon: "static/icons/user-journeys/sms_01.svg" },
        { value: "tiktok", title: "TikTok", icon: "static/icons/user-journeys/tiktok.png" }
    ]

    useEffect(() => {
        setMobileScroll(showFirst || showSecond || showThird.list || showThird.range);
    }, [showFirst, showSecond, showThird])

    const active1 = firstOptions.findIndex((option) => option.value === filter["channel"])
    const active1Title = firstOptions[active1] ? firstOptions[active1].title : 'Originating Channel'
    const firstDisplay = firstOptions.map((option, i) => {

        const optionDisplay = option.value === 'all' ? 'All' : option.title;
        return (
            <>
                <div onClick={() => changeFirstFilter(option.value)} className={`filter-option`} key={i}>
                    <div>
                        {option.icon && (
                            <span className={`main-icon-container`}>
                                <img src={option.icon} className={`main-icon`} />
                            </span>
                        )}
                        {!option.icon && (
                            <span className={`dropdown-spacer`}></span>
                        )}
                        {optionDisplay}
                    </div>
                    <Radio />
                </div>
            </>
        )

    })

    useEffect(() => {
        window.addEventListener("resize", () => setIsMobile(screen.width <= 766));
    }, [])

    toggleFirstFilter = () => {
        setShowFirst(!showFirst);
        setShowSecond(false);
        setShowThird({ list: false, range: false });
    }

    toggleSecondFilter = () => {
        setShowSecond(!showSecond);
        setShowFirst(false);
        setShowThird({ list: false, range: false });
    }

    useEffect(() => {
        if (showThird.list || showThird.range) {
            setShowFirst(false);
            setShowSecond(false);
        }
    }, [showThird])

    changeFilter = (k, v) => {
        filter[k] = v;
        setFilter(filter);
        LocalStorage.set(Constants.USER_JOURNEYS_FILTER, filter)
    }

    changeFirstFilter = (val) => {

        setFilter({
            ...filter,
            ["channel"]: val,
            ["campaign"]: 'all'
        });
        toggleFirstFilter();
        setIsMobileFilterOpen(false);
    }

    changeSecondFilter = (val) => {
        setFilter({
            ...filter,
            ["campaign"]: val.utm_campaign
        });
        toggleSecondFilter();
        setIsMobileFilterOpen(false);
    }

    const icon = 'static/icons/user-journeys/carat_01.svg'
    const active2Title = allCampaigns.find((option) => option.utm_campaign === (filter["campaign"] === "all" ? '' : filter["campaign"]))?.utm_campaign || "Campaign";
    const secondDisplay = allCampaigns.map((option, i) => {
        return (<div onClick={() => changeSecondFilter(option)} className={`filter-option`} key={i}>{option.utm_campaign}<Radio /></div>)
    });

    // Add "All" selection to secondDisplay
    secondDisplay.unshift(<div onClick={() => changeSecondFilter('all')} className={`filter-option`} key={`00`}>{`All Campaigns`}</div>)

    const onDateConfirm = ({ selected, dates }) => {
        setDateRangeListSelect({ selected: selected, dates: dates.map((date) => moment(date)) });
        setFilter({ ...filter, date: dates.map((date) => moment(date)) });
    }

    return (
        <>
            {isMobile ?
                <div className={`filter-sect`}>
                    <Button className="btnFilter" onClick={() => setIsMobileFilterOpen(!isMobileFilterOpen)}><img className="select-icon" src={filterIcon} alt="select icon" /> Filter</Button>
                    <div className="update-label"><label>Updated just now</label> <img className="refresh-icon" onClick={() => onSearch()} src={refresh} alt="select icon" /></div>
                    {/* <div className="topmenu-title">
                    <h5><span>{eventDetail?.count}</span> Purchases totalling <span>${Math.round(eventDetail?.purchaseAmount, 0)}</span> </h5>
                </div> */}
                </div>
                : ""}
            {!isMobile || (isMobileFilterOpen) ?
                <div className={`dropdown-main`}>
                    {!isMobile && <div className="topmenu-title">
                        <h5><span>{eventDetail?.count}</span> Purchases totalling <span>${Math.round(orZero(eventDetail?.purchaseAmount), 0)}</span></h5>
                    </div>}
                    <div className="dropdown-wrapper">
                        <div className={`filter-container first-filter`}>
                            <div className={`active-selection`}>
                                <button onClick={toggleFirstFilter} className={`filter-button first-button`}>
                                    {active1Title}
                                    <span className={`icon-container`}>
                                        <img src={icon} className={`carat`} />
                                    </span>
                                </button>
                            </div>
                            {showFirst && (
                                <div className={`show-hide first-show-hide`}>
                                    <div className="filter-menubar">
                                        <p>Select one or more </p>
                                        <img src={close} alt="close" onClick={() => setShowFirst(!showFirst)} />
                                    </div>
                                    {firstDisplay}
                                </div>
                            )}
                        </div>
                        <div className={`filter-container second-filter`}>
                            <div className={`active-selection`}>
                                <button onClick={toggleSecondFilter} className={`filter-button second-button`}>
                                    {active2Title}
                                    <span className={`icon-container`}>
                                        <img src={icon} className={`carat`} />
                                    </span>
                                </button>
                            </div>
                            {showSecond && (
                                <div className={`show-hide second-show-hide`}>
                                    <div className="filter-menubar">
                                        <p>Select one or more </p>
                                        <img src={close} alt="close" onClick={() => setShowSecond(false)} />
                                    </div>
                                    {secondDisplay}
                                </div>
                            )}
                        </div>
                        <div className={`filter-container`}>
                            <DateRangePicker dateRange={dateRangeListSelect} showDatePanel={showThird} onSetShowDatePanel={setShowThird} onSetDateRange={(r) => onDateConfirm(r)} setMobileScroll={setMobileScroll} />
                        </div>
                    </div>
                </div>
                : ""}
            {isMobile ? <div className="topmenu-title">
                <h5><span>{eventDetail?.count}</span> Purchases totalling <span>${Math.round(orZero(eventDetail?.purchaseAmount), 0)}</span> </h5>
            </div> : ""}
        </>
    )
}